var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5826_32967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 16.6668C16.3688 16.6668 16.6673 16.3684 16.6673 16.0002C16.6673 15.632 16.3688 15.3335 16.0007 15.3335C15.6325 15.3335 15.334 15.632 15.334 16.0002C15.334 16.3684 15.6325 16.6668 16.0007 16.6668Z",
    fill: "#3F3F3F",
    stroke: "#3F3F3F",
    strokeWidth: 2.72878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 25.3332C21.154 25.3332 25.3327 21.1545 25.3327 15.9998C25.3327 10.8452 21.154 6.6665 15.9993 6.6665C10.8447 6.6665 6.66602 10.8452 6.66602 15.9998C6.66602 21.1545 10.8447 25.3332 15.9993 25.3332Z",
    stroke: "#3F3F3F",
    strokeWidth: 2.72878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4V6.66667",
    stroke: "#3F3F3F",
    strokeWidth: 2.72878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 16H6.66667",
    stroke: "#3F3F3F",
    strokeWidth: 2.72878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25.3335V28.0002",
    stroke: "#3F3F3F",
    strokeWidth: 2.72878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.332 16H27.9987",
    stroke: "#3F3F3F",
    strokeWidth: 2.72878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5826_32967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.df855c0d688b4580e94737929295ba9b.svg";
export { ForwardRef as ReactComponent };